export default class SrcSets {
  public static hqcover = [240, 320, 360, 480, 512, 640, 768, 1000, 1920]
  public static cover = [240, 320, 360, 480, 512, 640, 768, 1000]
  public static logo = [16, 24, 32, 48, 64, 128, 256]
  public static coverLq = 64
}
